import React from "react";
import { useDispatch } from "react-redux";
import { updateAppointment } from "../redux/slices/appointmentSlice";
import { AppDispatch } from "../redux/store";
import { AppointmentState } from "../types";
import { sendToWindowDataLayer } from "../utils/dom";
import {
  buttonPrimary,
  buttonSecondary,
  cardHeaderClass,
  cardBodyClass,
} from "css";
import { ApptType } from "types/booking-config.interface";

interface StayOrDropSelectorProps {
  appointment: AppointmentState;
  stayOrDropOff: ApptType | undefined;
  setStayOrDropOff: (value: ApptType) => void;
}

export const StayOrDropSelector: React.FC<StayOrDropSelectorProps> = ({
  appointment,
  stayOrDropOff,
  setStayOrDropOff,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      <div
        className={`${cardHeaderClass} flex justify-between`}
        style={{ backgroundColor: appointment?.shopData?.color }}
      >
        Will you be dropping your vehicle off?
        <span className="relative flex h-3 w-3 pt-1.5">
          {stayOrDropOff ? (
            <>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-600"></span>
            </>
          ) : (
            <>
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600"></span>
            </>
          )}
        </span>
      </div>
      <div
        className={cardBodyClass}
        style={{ borderColor: appointment?.shopData?.color }}
      >
        <div className="grid grid-cols-2 gap-5 p-2">
          {(["wait", "drop"] as ApptType[]).map((choice: ApptType) => (
            <div
              key={choice}
              data-dc-service={`dc-service-${choice}`}
              onClick={() => {
                if (appointment?.dropOffOnly && choice === "drop") {
                  dispatch(
                    updateAppointment({
                      updates: { apptType: choice },
                    })
                  );

                  setStayOrDropOff(choice);
                } else if (!appointment?.dropOffOnly) {
                  dispatch(
                    updateAppointment({
                      updates: { apptType: choice },
                    })
                  );

                  setStayOrDropOff(choice);
                }

                if (choice === "wait") {
                  sendToWindowDataLayer("dc-service-wait_or_drop", "Stay");
                } else if (choice === "drop") {
                  sendToWindowDataLayer("dc-service-wait_or_drop", "Drop Off");
                }
              }}
            >
              <center>
                <div
                  className={`size-20 md:w-[160px] md:h-[80px] p-2 ${
                    choice === stayOrDropOff ? buttonSecondary : buttonPrimary
                  } ${
                    appointment?.dropOffOnly && choice === "wait"
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  } ${
                    appointment?.dropOffOnly &&
                    choice === "wait" &&
                    "text-gray-300 hover:text-gray-300"
                  }`}
                  style={{
                    backgroundColor:
                      choice === stayOrDropOff
                        ? appointment?.shopData?.color
                        : "white",
                    border: `1px solid ${appointment?.shopData?.color}`,
                    boxShadow:
                      appointment?.shopData?.shadow === "shadow-md"
                        ? `0 4px 6px ${appointment?.shopData?.color}33`
                        : "none",
                  }}
                >
                  {choice === "wait"
                    ? appointment?.dropOffOnly
                      ? appointment?.shopData?.messages?.dropOffOnlyMessage
                        ? appointment?.shopData?.messages?.dropOffOnlyMessage
                        : "This is a drop off only service"
                      : "Stay"
                    : "Drop Off"}
                </div>
              </center>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
